<template>
  <el-select
    clearable
    v-model="gateId"
    :placeholder="placeholder"
    @visible-change="server"
    @change="setValue"
    v-bind="$attrs"
    :disabled="isDisabled"
  >
    <el-option
      v-for="item in ParkLotGateUuidList"
      :key="String(item[selectKey])"
      :label="item.Name"
      :value="String(item[selectKey])"
    ></el-option>
  </el-select>
</template>

<script>
import { queryParkLotGate } from "../api/module/tenant";
import parkLotMix from "../minxs/parkLotId";
// import park from '../'
export default {
  data() {
    return {
      gateId: "",
      ParkLotGateUuidList: [],
    };
  },
  props: {
    value: [String, Number],
    Direction: {
      type: Number,
      default: 1,
    },
    selectKey: {
      type: [String, Number],
      default: "Id",
    },
    isDisabled: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: "请选择道闸",
    },
  },
  mixins: [parkLotMix],
  mounted() {
    // console.log("属性", this);
  },
  methods: {
    server: function (bool) {
      if (bool) {
        queryParkLotGate({
          Page: 1,
          PerPage: 100,
          ParkLotId: this.ParkLotId,
          Direction: this.Direction,
          SentryBoxId: Number(sessionStorage.getItem('sentryId')),
          // IsBindCam: 1,
        }).then((res) => {
          if (res.state === "success") {
            this.ParkLotGateUuidList = res.data;
            this.gateId = String(this.value);
            // console.log(this.value);
            this.setValue(this.value)
          } else {
            this.ParkLotGateUuidList = [];
          }
        });
      }
    },
    setValue(value) {
      let data = this.ParkLotGateUuidList.filter((item) => {
        return item[this.selectKey] === Number(value);
      });
      this.$emit("input", value);
      this.$emit("change", data[0]);
    },
  },
};
</script>

<style>
</style>
